import axios from 'axios';

export default class CategoryService {
  async getCategory(projectId, categoryId) {
    const response = await axios({
      method: 'get',
      url: `projects/${projectId}/categories/${categoryId}`,
      withCredentials: true,
    }).catch((error) => {
      console.log('getCategory, categories', error);
      throw error;
    });
    return response.data;
  }

  async getAllCategories(projectId) {
    const response = await axios({
      method: 'get',
      url: `projects/${projectId}/categories`,
      withCredentials: true,
    }).catch((error) => {
      console.log('getCategory, categories', error);
      throw error;
    });
    return response.data;
  }

  async getProjects(projectId) {
    const allCategories = await this.getAllCategories(projectId);
    const projects = allCategories.categories.find((category) => category.name === 'Incomes');
    return await this.getCategory(projectId, projects.id);
  }

  async getInternalProjects(projectId) {
    const allCategories = await this.getAllCategories(projectId);
    const internalProjects = allCategories.categories.find(
      (category) => category.name === 'Internal Projects',
    );
    return await this.getCategory(projectId, internalProjects.id);
  }
}
